<template>
  <!-- 话务管理-通话查询 -->
  <basic-container>
    <avue-crud
      ref="crud"
      :option="tableOption"
      :table-loading="loading"
      :data="tableData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="loadData"
      @on-load="loadData"
    >
      <template slot="menuLeft">
        <AudioBar v-if="audioInfo" :audioInfo="audioInfo"></AudioBar>
      </template>
      <template slot-scope="{ row }" slot="menu">
        <el-button
          v-if="permissionList.addOrderBtn && !row.orderNo"
          type="text"
          size="small"
          @click="addOrder(row)"
        >
          新建工单
        </el-button>
      </template>
      <template slot="dateRangeSearch">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 100%"
        >
        </el-date-picker>
      </template>
      <template slot="radio" slot-scope="{ row }">
        <el-radio v-model="selectRowIndex" :label="row.$index" @change="rowClick(row)">
          <span>{{ '' }}</span>
        </el-radio>
      </template>
      <template slot="orderNo" slot-scope="{ row }">
        <el-button
          type="text"
          size="small"
          v-for="orderCode in row.orderNo.split(',')"
          :key="orderCode"
          @click="showOrderDetail({ orderCode })"
        >
          {{ orderCode.split('-')[0] }}
        </el-button>
      </template>
      <template slot="callRingDuration" slot-scope="{ row }">
        <span> {{ row.callRingDuration ? row.callRingDuration + 's' : '' }} </span>
      </template>
      <template slot="callDuration" slot-scope="{ row }">
        <span> {{ secondsToDuration(row.callDuration, 'chi') }} </span>
      </template>
    </avue-crud>
    <!-- 工单详情的显隐逻辑由详情组件自己控制的，其显隐状态也不会通知父组件 -->
    <Orderdetail ref="orderDetailRef" :orderInfo="orderInfo"></Orderdetail>
    <AddOrder ref="addOrder" @success="createOrderSuccess"></AddOrder>
  </basic-container>
</template>

<script>
import { mapGetters } from 'vuex';
import AddOrder from '../../components/add-order';
import AudioBar from '../../components/audio-bar';
import Orderdetail from '../../components/order-detail';
import { getProjectListApi } from '@/api/call-system/index';
import { getPageListApi, updateRecordApi } from '@/api/call-system/call-manage/call-query';
import { secondsToDuration } from '../../common';

export default {
  components: {
    AddOrder,
    AudioBar,
    Orderdetail,
  },
  data() {
    return {
      oldProjectId: '', // 旧项目id，重置搜索条件和新增时需要使用
      projectList: [], // 项目列表
      searchForm: {}, // 搜索条件
      dateRange: [], // 搜索条件-起止日期
      selectRowIndex: -1, // 选中的行在当前页的序号
      rowData: null, // 选中的行对应的数据
      audioInfo: null, // 选中的行对应的数据
      orderInfo: null, // 工单信息
      loading: false, // 是否正在加载表格数据
      tableData: [], // 表格数据
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格显示的配置项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        dialogClickModal: false,
        searchMenuSpan: 24,
        searchLabelWidth: 80,
        menuWidth: 100,
        column: [
          {
            label: '选择',
            prop: 'radio',
            width: 50,
            slot: true,
          },
          {
            label: '项目名称',
            prop: 'projectId',
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
            },
            type: 'select',
            hide: true,
            showColumn: false,
            display: false,
            // search: true,
            // searchClearable: false,
          },
          {
            label: '日期',
            prop: 'dateRange',
            display: false,
            showColumn: false,
            search: true,
            searchslot: true,
            searchSpan: 12,
          },
          {
            label: '号码',
            prop: 'customerTel',
            display: false,
            showColumn: false,
            search: true,
            maxlength: 12,
            showWordLimit: true,
          },
          {
            label: '主叫号码',
            prop: 'fromPhone',
            maxlength: 13,
            width: 100,
          },
          {
            label: '客户姓名',
            prop: 'customerName',
            overHidden: true,
          },
          {
            label: '联系电话',
            prop: '_customerTel',
            width: 100,
            formatter: (row) => {
              return row.customerTel;
            },
          },
          {
            label: '性别',
            prop: 'customerGender',
            width: 60,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=sex',
            props: { label: 'dictValue', value: 'dictKey' },
          },
          {
            label: '客户类型',
            prop: 'customerType',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=telephone_customer_type',
            props: { label: 'dictValue', value: 'dictKey' },
          },
          {
            label: '服务类别',
            prop: 'serviceType',
            search: true,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=call_service_type',
            props: { label: 'dictValue', value: 'dictKey' },
          },
          {
            label: '被叫号码',
            prop: 'toPhone',
            maxlength: 13,
            width: 100,
          },
          {
            label: '呼叫方向',
            prop: 'callType',
            search: true,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=call_type',
            props: { label: 'dictValue', value: 'dictKey' },
          },
          {
            label: '坐席工号',
            prop: 'serviceNo',
          },
          {
            label: '开始时间',
            prop: 'callStartTime',
            width: 160,
          },
          {
            label: '结束时间',
            prop: 'callEndTime',
            width: 160,
          },
          {
            label: '振铃时长',
            prop: 'callRingDuration',
            slot: true,
          },
          {
            label: '通话时长',
            prop: 'callDuration',
            slot: true,
            width: 120,
          },
          {
            label: '内容记录',
            prop: 'description',
            overHidden: true,
          },
          {
            label: '通话满意度',
            prop: 'score',
            width: 100,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=callcenter_evaluate',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '关联工单',
            prop: 'orderNo',
            slot: true,
            minWidth: 140,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addOrderBtn: this.vaildData(this.permission.callSystem_callManage_callQuery_add, false),
      };
    },
  },
  created() {
    getProjectListApi().then(({ data }) => {
      this.projectList = data || [];
      if (this.projectList.length > 0) {
        this.findObject(this.tableOption.column, 'projectId').dicData = this.projectList;
        this.searchForm.projectId = this.projectList[0].id;
        this.loadData();
      }
    });
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    secondsToDuration: secondsToDuration,
    /* 调整视图区域 */
    ajustView() {
      const tableInitH = this.bodyHeight - 395; // 表格区域初始化高度
      const searchH = 117; // 搜索区域占的高度
      this.tableOption.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.tableOption.height == tableInitH) {
              this.tableOption.height = tableInitH + searchH;
            } else {
              this.tableOption.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    /* 加载表格数据 */
    loadData(page) {
      if (!this.searchForm.projectId) return;
      this.oldProjectId = this.searchForm.projectId;
      page = page || this.tablePage;
      this.loading = true;
      getPageListApi(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.searchForm)
      ).then(({ data }) => {
        this.tablePage.total = data.total;
        this.tableData = data.records;
        this.selectRowIndex = -1;
        this.loading = false;
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.selectRowIndex = -1;
      this.dateRange = [];
      this.searchForm = {
        projectId: this.oldProjectId,
      };
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.selectRowIndex = -1;
      this.searchForm = params;
      this.dealDateRange();
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    /* 转化日期范围 */
    dealDateRange() {
      if (this.dateRange && this.dateRange.length > 0) {
        this.searchForm.callStartTimeBegin = this.dayjs(this.dateRange[0]).format(
          'YYYY-MM-DD 00:00:00'
        );
        this.searchForm.callStartTimeEnd = this.dayjs(this.dateRange[1]).format(
          'YYYY-MM-DD 23:59:59'
        );
      } else {
        this.searchForm.callStartTimeBegin = '';
        this.searchForm.callStartTimeEnd = '';
        this.dateRange = [];
      }
    },
    /* 行点击 */
    rowClick(row) {
      this.selectRowIndex = row.$index;
      this.audioInfo = this.tableData[this.selectRowIndex];
    },
    /* 显示工单详情 */
    showOrderDetail(orderInfo) {
      this.orderInfo = orderInfo;
      this.$refs.orderDetailRef.show();
    },
    addOrder(rowData) {
      this.rowData = rowData;
      this.$refs.addOrder.showDialog(rowData);
    },
    createOrderSuccess(orderInfo) {
      let params = {
        id: this.rowData.id,
        orderNo: orderInfo.code + '-' + orderInfo.projectId,
      };
      updateRecordApi(params).then(() => {
        this.loadData();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
